import { Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useRecurringInvoiceForm } from '../../../../../../../../../../../../contexts/recurringInvoiceFormContext'

export const EmailMessage = (): ReactElement => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()
  const { FormItem } = recurringInvoiceForm

  return (
    <FormItem
      name="message.body"
      label={t(
        'external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.email_message.label',
      )}
      render={({ field }) => {
        return (
          <Textarea
            {...field}
            expandOnType
            maxHeight={160}
            placeholder={t(
              'external_invoices.editor.form.recurring_invoice_settings.email_template.modal.field.email_message.placeholder',
            )}
            resizable={false}
            rows={5}
            size="sm"
          />
        )
      }}
    />
  )
}
